import React from 'react'
import { Box } from '@chakra-ui/react'
import { Image } from '@chakra-ui/react'
import { useDisclosure } from '@chakra-ui/react'

import { AttachmentItemProps } from '.'
import RemoveAttachmentButton from './remove-button'
import FullScreenPreview from './full-screen-preview'

export default function PhotoAttachment({
    attachment,
    onRemove,
}: AttachmentItemProps) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <Box
                height="full"
                bg="gray.100"
                overflow="hidden"
                borderRadius="lg"
                position="relative"
                _dark={{
                    bg: 'gray.800',
                }}
                role="group"
                cursor="pointer"
            >
                <Image
                    position="relative"
                    h="full"
                    w="full"
                    objectFit="cover"
                    alt={attachment.filename}
                    src={attachment.url}
                />
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    bottom={0}
                    left={0}
                    _groupHover={{ bg: 'blackAlpha.200' }}
                    onClick={onOpen}
                />
                {onRemove && <RemoveAttachmentButton onClick={onRemove} />}
            </Box>
            <FullScreenPreview
                attachment={attachment}
                isOpen={isOpen}
                onClose={onClose}
                showDownload={true}
            />
        </>
    )
}
